module.exports = __webpack_public_path__ + "img/electro.31d37793.svg";